<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/G9A1nr/tc-custom/9798368807492.jpg?1718251154549" alt="This image is the cover for the book CREEPSHOW: HOLIDAY SPECIAL 2023 (ONE SHOT), CREEPSHOW"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">CREEPSHOW: HOLIDAY SPECIAL 2023 (ONE SHOT), CREEPSHOW
      </h1>
      <p class="bookDescription body article font2">
        <p>“CREEPSHOW is here to put the fear in your cheer!  You’ve heard of Santa, you’ve heard of Krampus, but have you ever heard of “The Christmas Man”? Witness the birth of a new horrifying holiday classic from DANIEL DONT CALL ME SANTA KRAUS (The Shape of Water) and jolly JONATHAN WAYSHAK (Skin Crawl)!  Then, jovial JAMES ASMUS (Survival Street, Rick Morty) and lively LETIZIA CADONICI (House of Slaughter) deliver a cautionary tale about stealing the wrong parcel in “Package Thief.”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jonathan Wayshak, Jonathan Wayshak, Letizia Cadonici
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Image Comics
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4087b01a